import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { ChangePassComponent } from "./change-pass/change-pass.component";
import { ClientBackorderComponent } from "./clients/client-backorder/client-backorder.component";
import { ClientDetailsComponent } from "./clients/client-details/client-details.component";
import { ClientsComponent } from "./clients/clients.component";
import { ConstructionInformationComponent } from "./construction/construction-information/construction-information.component";
import { ConstructionComponent } from "./construction/construction.component";
import { CreateConstructionComponent } from "./construction/create-construction/create-construction.component";
import { CreateLoadhseetDeliveryComponent } from "./create-loadsheet-delivery/create-loadhseet-delivery.component";
import { CreateMaintenanceComponent } from "./maintenance/create-maintenance/create-maintenance.component";
import { CreateOrdersComponent } from "./create-orders/create-orders.component";
import { CreateProjectOrderComponent } from "./create-orders/create-project-order/create-project-order.component";
import { CreateVirtualOrdersComponent } from "./create-orders/create-virtual-orders/create-virtual-orders.component";
import { CsvUploaderComponent } from "./csv-uploader/csv-uploader.component";
import { DailyHealthChecksComponent } from "./daily-health-checks/daily-health-checks.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { DeliveryInformationComponent } from "./delivery/delivery-information/delivery-information.component";
import { DeliveryComponent } from "./delivery/delivery.component";
import { EditVirtualOrderComponent } from "./edit-virtual-order/edit-virtual-order.component";
import { EmployeeDetailsComponent } from "./employee-details/employee-details.component";
import { EmployeeListComponent } from "./employee-list/employee-list.component";
import { HealthInformationComponent } from "./health-information/health-information.component";
import { LoadsheetInformationComponent } from "./loadsheet/loadsheet-information/loadsheet-information.component";
import { LoadsheetComponent } from "./loadsheet/loadsheet.component";
import { LoginComponent } from "./login/login.component";
import { MaintenanceRequestComponent } from "./maintenance/maintenance-request/maintenance-request.component";
import { MaintenanceComponent } from "./maintenance/maintenance.component";
import { OrderComponent } from "./order/order.component";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { ProductSublistComponent } from "./product/product-sublist/product-sublist.component";
import { CreateProductComponent } from "./product/create-product/create-product.component";
import { ProductComponent } from "./product/product.component";
import { ProjectOrderComponent } from "./project/project-order/project-order.component";
import { ProjectComponent } from "./project/project.component";
import { ShopAdminComponent } from "./shop-admin/shop-admin.component";
import { VirtualOrdersComponent } from "./order/virtual-orders/virtual-orders.component";
import { EditClientDetailsComponent } from "./clients/edit-client-details/edit-client-details.component";
import { MaintenanceNoteNumberComponent } from "./maintenance/maintenance-note-number/maintenance-note-number.component";
import { MaintenanceHistoryComponent } from "./maintenance/maintenance-history/maintenance-history.component";
import { HealthCheckNoteNumberComponent } from "./daily-health-checks/health-check-note-number/health-check-note-number.component";
import { GenerateReportPdfComponent } from "./generate-report-pdf/generate-report-pdf.component";

// import { OrderListComponent } from './order-list/order-list.component';
// import { ClientDeliveryComponent } from './client-delivery/client-delivery.component';
const routes: Routes = [
  {
    path: "privacy-policy",
    component: PrivacyPolicyComponent,
  },
  {
    path: "",
    component: LoginComponent,
  },
  {
    path: "change-password",
    component: ChangePassComponent,
  },
  {
    path: "edit-client-details",
    component: EditClientDetailsComponent,
  },
  {
    path: "clients",
    component: ClientsComponent,
  },
  {
    path: "client-details",
    component: ClientDetailsComponent,
  },
  {
    path: "orders-list",
    component: OrderComponent,
  },
  {
    path: "client-orders-list", //for client
    component: OrderComponent,
  },
  {
    path: "client-virtual-orders-list", //for client
    component: VirtualOrdersComponent,
  },
  {
    path: "edit-virtual-order", //for client
    component: EditVirtualOrderComponent,
  },
  // {
  //   path: 'client-delivery',
  //   component: ClientDeliveryComponent
  // },
  {
    path: "delivery-info",
    component: DeliveryInformationComponent,
  },
  {
    path: "client-delivery-info",
    component: DeliveryInformationComponent,
  },
  {
    path: "client-create-order",
    component: CreateOrdersComponent,
  },
  {
    path: "client-create-virtual-order",
    component: CreateVirtualOrdersComponent,
  },
  {
    path: "generate-note-number",
    component: GenerateReportPdfComponent,
  },
  {
    path: "create-loadsheet-delivery",
    component: CreateLoadhseetDeliveryComponent,
  },
  {
    path: "client-loadsheets",
    component: LoadsheetComponent,
  },
  {
    path: "loadsheet-info",
    component: LoadsheetInformationComponent,
  },
  {
    path: "client-loadsheet-info",
    component: LoadsheetInformationComponent,
  },
  {
    path: "construction",
    component: ConstructionComponent,
  },
  {
    path: "construction-info",
    component: ConstructionInformationComponent,
  },
  {
    path: "create-construction",
    component: CreateConstructionComponent,
  },
  {
    path: "loadsheets",
    component: LoadsheetComponent,
  },
  {
    path: "emp-list",
    component: EmployeeListComponent,
  },
  {
    path: "delivery-list",
    component: DeliveryComponent,
  },
  {
    path: "client-delivery-list",
    component: DeliveryComponent,
  },

  {
    path: "product-list",
    component: ProductComponent,
  },
  {
    path: "product-component",
    component: ProductSublistComponent,
  },
  {
    path: "dashboard",
    component: DashboardComponent,
  },
  {
    path: "manage-product",
    component: CsvUploaderComponent,
  },
  {
    path: "client-backorder",
    component: ClientBackorderComponent,
  },
  {
    path: "emp-details",
    component: EmployeeDetailsComponent,
  },
  {
    path: "project",
    component: ProjectComponent,
  },

  {
    path: "projectorder",
    component: ProjectOrderComponent,
  },
  {
    path: "maintenance",
    component: MaintenanceComponent,
  },
  {
    path: "create-maintenance",
    component: CreateMaintenanceComponent,
  },
  {
    path: "maintenance-note-number",
    component: MaintenanceNoteNumberComponent,
  },
  {
    path: "maintenance-history",
    component: MaintenanceHistoryComponent,
  },
  {
    path: "health-check-note-number",
    component: HealthCheckNoteNumberComponent,
  },
  {
    path: "createprojectorder",
    component: CreateProjectOrderComponent,
  },
  {
    path: "maintenance-request",
    component: MaintenanceRequestComponent,
  },
  {
    path: "shop-admin",
    component: ShopAdminComponent,
  },
  {
    path: "daily-health-check",
    component: DailyHealthChecksComponent,
  },
  {
    path: "create-product",
    component: CreateProductComponent,
  },
  {
    path: "health-check-information",
    component: HealthInformationComponent,
  },
  {
    path: "**",
    component: LoginComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
